import React from 'react'
import SearchTab from './SearchTab'

const Search = () => {
    return (
        <div>
            <SearchTab />
        </div>
    )
}

export default Search